import { inject, ModuleWithProviders, NgModule, provideAppInitializer } from '@angular/core';
import { SmartEditLauncherService } from '@spartacus/smartedit/root';
import { BaseTmsModule, TmsService } from '@spartacus/tracking/tms/core';
import { TrackingEventModule } from './events/tracking-events.module';
import { GaModule } from './ga';
import { GtmModule } from './gtm';
import { UmamiModule } from './umami';

export function tmsFactory(service: TmsService, smartEditLauncherService: SmartEditLauncherService): () => void {
  return smartEditLauncherService.isLaunchedInSmartEdit() ? () => {} : () => service.collect();
}

@NgModule({})
export class PyBaseTmsModule {
  static forRoot(): ModuleWithProviders<BaseTmsModule> {
    return {
      ngModule: BaseTmsModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = tmsFactory(inject(TmsService), inject(SmartEditLauncherService));
          return initializerFn();
        }),
      ],
    };
  }
}

@NgModule({
  declarations: [],
  imports: [PyBaseTmsModule.forRoot(), GtmModule, GaModule, UmamiModule, TrackingEventModule],
})
export class TrackingFeatureModule {}
